import { useTranslation } from 'src/core/common/hooks/useTranslation';
import {
  NotificationType,
  useNotifications,
} from 'src/core/modules/app/notifications';

import { useTriggerSurvey } from '../../event-tracking/useTriggerSurvey';
import { useUpdateOrganisationSetting } from '../../hooks/useUpdateOrganisationSetting';
import { type Setting } from '../../setting';
import { CommonModal } from '../CommonModal';
import {
  CostCenterDetailsContent,
  type CostCenterDetailsFormValues,
} from '../CostCenterDetailsContent';

export const CostCenterDetailsEditModal = ({
  setting,
  isOpen,
  onCancel,
}: {
  setting: Setting;
  isOpen: boolean;
  onCancel: () => void;
}) => {
  const { t } = useTranslation('global');
  const { pushNotif } = useNotifications();
  const { mutate: updateOrganisationSEtting } =
    useUpdateOrganisationSetting(setting);
  const triggerSurvey = useTriggerSurvey();

  const handleDetailsComplete = async (values: CostCenterDetailsFormValues) => {
    try {
      await updateOrganisationSEtting({
        name: values.name,
        ownerId: values.ownerId,
        viewerIds: values.viewerIds,
      });
    } catch (error) {
      pushNotif({
        type: NotificationType.Danger,
        message: t('multiEntityHub.costCenters.messages.errorUpdateCostCenter'),
      });
      throw error;
    }

    triggerSurvey();
    pushNotif({
      type: NotificationType.Success,
      message: t('multiEntityHub.costCenters.messages.successUpdateCostCenter'),
    });
    onCancel();
  };

  return (
    <CommonModal
      isOpen={isOpen}
      title={t('multiEntityHub.costCenters.modal.details.titleEdit')}
      iconName="pen"
      onClose={onCancel}
    >
      <CostCenterDetailsContent
        onComplete={handleDetailsComplete}
        onCancel={onCancel}
        setting={setting}
        mode="singleModal"
      />
    </CommonModal>
  );
};
